<h2 class="bd-title">Log Settings</h2>
@if (successMessage) {
<alert type="success" [dismissible]="true" (onClose)="successMessage = undefined">
  <coso-alert-message>{{ successMessage }}</coso-alert-message>
</alert>
} @if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}

<form #settingsForm="ngForm" id="settingsForm">
  @if (settings$ | async; as settings) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <div id="crmLogHistoryEnabledLabel" class="cs-larger-text cs-bolder-text">Store logs in Dynamics 365</div>
      <div id="crmLogHistoryEnabledSubLabel" class="cs-secondary-text">Set whether system logs are stored in Dynamics 365 into the <i>CB Replicator Log</i> entity.</div>
    </div>
    <div class="custom-control custom-switch">
      <input
        role="switch"
        type="checkbox"
        class="custom-control-input"
        id="crmLogHistoryEnabled"
        name="crmLogHistoryEnabled"
        aria-labelledby="crmLogHistoryEnabledLabel"
        aria-describedby="crmLogHistoryEnabledSubLabel"
        [attr.aria-checked]="settings.crmLogHistoryEnabled"
        [(ngModel)]="settings.crmLogHistoryEnabled"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="readonly$ | async"
      />
      <label class="custom-control-label" for="crmLogHistoryEnabled">{{ settings.crmLogHistoryEnabled ? 'On' : 'Off' }}</label>
    </div>
  </div>
  @if (isSaaS === false) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <div id="logHistoryEnabledLabel" class="cs-larger-text cs-bolder-text">Store logs in database</div>
      <div id="logHistoryEnabledSubLabel" class="cs-secondary-text">Set whether system logs are stored in the local database into the <i>LogEntry</i> table.</div>
    </div>
    <div class="d-lg-flex justify-content-lg-between" [class.w-25]="isSaaS === false">
      <button
        type="button"
        id="clearLogsButton"
        class="btn btn-danger btn-sm"
        placement="top"
        data-toggle="tooltip"
        data-placement="top"
        data-original-title="Clear system logs cache from local database"
        (click)="openConfirmationModal()"
        [disabled]="readonly$ | async"
      >
        <span class="fa fa-fw fa-eraser mr-1" aria-hidden="true"></span>Clear logs
      </button>
      <div class="custom-control custom-switch">
        <input
          role="switch"
          type="checkbox"
          class="custom-control-input"
          id="logHistoryEnabled"
          name="logHistoryEnabled"
          aria-labelledby="logHistoryEnabledLabel"
          aria-describedby="logHistoryEnabledSubLabel"
          [attr.aria-checked]="settings.logHistoryEnabled"
          [(ngModel)]="settings.logHistoryEnabled"
          (ngModelChange)="updateSettings(settings)"
          [disabled]="readonly$ | async"
        />
        <label class="custom-control-label" for="logHistoryEnabled">{{ settings.logHistoryEnabled ? 'On' : 'Off' }}</label>
      </div>
    </div>
  </div>
  }
  }
</form>

<ng-template #deleteConfirmation>
  <form #form="ngForm" (ngSubmit)="clearDatabaseLogs()">
    <div class="modal-header">
      <div class="modal-title h5" id="modalTitle"><span class="fa fa-exclamation-triangle text-warning mr-1" aria-hidden="true"></span>Delete Logs</div>
      <button type="button" class="close" aria-label="Close modal?" (click)="modalRef.close()"><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body pl-5">
      <div class="form-group row align-items-center">
        <div class="custom-control custom-radio col-md-3">
          <input type="radio" name="olderThan" id="olderThan" class="custom-control-input" [value]="false" [(ngModel)]="shouldDeleteAll" />
          <label class="custom-control-label" for="olderThan">Older than</label>
        </div>
        <input
          min="1"
          id="numberOfDays"
          name="numberOfDays"
          type="number"
          class="form-control form-control-sm col-md-2"
          #numberOfDays="ngModel"
          [(ngModel)]="days"
          [class.is-invalid]="numberOfDays.dirty && numberOfDays.invalid && shouldDeleteAll === false"
          cosoRangeValidator
          [attr.aria-invalid]="numberOfDays.invalid"
        />
        <label class="col-md-2" for="numberOfDays">days</label>
        @if (numberOfDays.dirty && numberOfDays.invalid && shouldDeleteAll === false) {
        <span class="fa fa-times invalid-feedback-icon" aria-hidden="true"></span>
        } @if (numberOfDays.errors?.min && shouldDeleteAll === false) {
        <div class="invalid-feedback">The number of days must be greater than or equal to 1.</div>
        }
      </div>
      <div class="form-group row">
        <div class="custom-control custom-radio col-md-3">
          <input type="radio" id="deleteAll" name="deleteAll" class="custom-control-input" [value]="true" [(ngModel)]="shouldDeleteAll" />
          <label class="custom-control-label" for="deleteAll">Delete all</label>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalRef.close()">Cancel</button>
      <button type="submit" class="btn btn-danger">Delete</button>
    </div>
  </form>
</ng-template>
